module.exports = __webpack_public_path__ + "img/GAME_LIGHTBUG2.476868d3.jpg";